import axios from 'axios';
import { LocalStorageTeenus } from './local-storage-teenus';
import apiRoutes from '@/apiRoutes';
import { useKasutajaStore } from '@/stores/kasutajaStore';
import { useAmetnikStore } from '@/stores/ametnikStore';
import { useTeavitusedStore } from '@/stores/teavitusedStore';
import { useTegevusedStore } from '@/stores/tegevusedStore';
import { useUldkasulikTooStore } from '@/stores/uldkasulikTooStore';

export const onAuthStorageKey = 'isAuth';

const _localStorageTeenus = new LocalStorageTeenus();

export class AuthTeenus {

    public logiSisse(): void {
        (window as Window).location = apiRoutes.login;
    }

    public async kontrolliAuthi(): Promise<{ isAuth: boolean } | undefined> {
        try {
            const result = await axios.get<{ isAuth: boolean }>(apiRoutes.kontrolliAuth);
            _localStorageTeenus.salvesta(onAuthStorageKey, `${result.data.isAuth}`);
            return result.data
        } catch (e) {
            console.log(e);
        }
    }

    public logiValja(): void {
        this.resetLocalState();
        (window as Window).location = apiRoutes.logOut;
    }

    get onSisseLogitud(): boolean {
        return _localStorageTeenus.anna(onAuthStorageKey)?.toLowerCase() === 'true'
    }

    public backToVatek() {
        _localStorageTeenus.kustuta(onAuthStorageKey);
        (window as Window).location = apiRoutes.backToVatek;
    }
    public logoutVatek() {
        this.resetLocalState();
        (window as Window).location = apiRoutes.logoutVatek;
    }

    private resetLocalState() {
        const userStore = useKasutajaStore();
        const ametnikStore = useAmetnikStore();
        const teavitusedStore = useTeavitusedStore();
        const tegevusedStore = useTegevusedStore();
        const uldkasulikTooStore = useUldkasulikTooStore();
        userStore.eemaldaKasutaja();
        _localStorageTeenus.kustuta(onAuthStorageKey);
        ametnikStore.eemaldaAmetnik();
        teavitusedStore.eemaldaTeavitused();
        tegevusedStore.eemaldaTegevused();
        uldkasulikTooStore.eemaldaUldkasulikToo();
    }
}